import { render } from "./OvenPlayer.vue?vue&type=template&id=24d23927"
import script from "./OvenPlayer.vue?vue&type=script&lang=js"
export * from "./OvenPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__